import { render, staticRenderFns } from "./Black-list.vue?vue&type=template&id=3d4fb352"
import script from "./Black-list.vue?vue&type=script&lang=js"
export * from "./Black-list.vue?vue&type=script&lang=js"
import style0 from "./Black-list.vue?vue&type=style&index=0&id=3d4fb352&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports